package ui.app.assign.detail.definition

import androidx.compose.animation.*
import androidx.compose.foundation.layout.*
import androidx.compose.material3.Button
import androidx.compose.material3.Card
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import common.frontend.api.Io
import io.Repository
import kotlinx.coroutines.launch
import kotlinx.datetime.*
import kotlinx.datetime.format.char
import org.ssoft.common.tools.EMPTY
import ssoft.frontend.generated.resources.*
import tools.await
import tools.rememberString
import ui.app.assign.detail.AppDetailScope
import ui.snackBarStateGlobal
import ui.widget.Space
import kotlin.time.Duration.Companion.milliseconds

private val DATE_FORMAT = LocalDateTime.Format {
    year()
    char(' ')
    monthNumber()
    char('.')
    day()
    char('.')
    char(' ')
    hour()
    char(':')
    minute()
}

@Composable
fun AppDetailScope.AppDefOfRss(
    wrapper: AppDetailScope.Wrapper,
    nnvl: AppDetailScope.WrapperDefinition.OfRss
) {
    val channelState = remember {
        mutableStateOf<Io.RssState?>(null)
    }


    if (display.isMobile || display.resolution.width < 1400) {
        Column {
            DefaultFields(
                nnvl = wrapper,
                modifier = Modifier.fillMaxWidth()
            )
            Space(16.dp)
            ChannelState(channelState, Modifier.fillMaxWidth())
            Space(16.dp)
            ChannelReload(nnvl.data.content.channelId, channelState, Modifier.fillMaxWidth())
        }
    } else {
        Row {
            Column {
                DefaultFields(nnvl = wrapper)
            }
            Space(16.dp)
            Column(Modifier.weight(1F)) {
                ChannelState(channelState, Modifier.fillMaxWidth())
                Space(16.dp)
                ChannelReload(nnvl.data.content.channelId, channelState, Modifier.fillMaxWidth())
            }
        }
    }

}

@Composable
private fun ChannelReload(
    channelId: Long,
    channelState: MutableState<Io.RssState?>,
    modifier: Modifier = Modifier.width(256.dp)
) {
    val scope = rememberCoroutineScope()
    Button(
        enabled = channelState.value != null && channelState.value?.dtLast != LocalDateTime.EMPTY,
        modifier = modifier,
        onClick = {
            scope.launch {
                runCatching {
                    Repository.api.rss.reload(channelId)
                }.onFailure {
                    it.printStackTrace()

                    snackBarStateGlobal.showSnackbar(Res.string.layer_bottom_editor__rss_reload_fail.await(it.message ?: ""))
                }.onSuccess {
                    channelState.value = channelState.value?.copy(dtLast = LocalDateTime.EMPTY)
                    snackBarStateGlobal.showSnackbar(Res.string.layer_bottom_editor__rss_reload_start_info.await())
                }
            }
        }) {
        Text(Res.string.layer_bottom_editor__rss_reload_label.rememberString())
    }

    LaunchedEffect(Unit) {
        runCatching {
            channelState.value = Repository.api.rss.state(channelId)
        }.onFailure {
            it.printStackTrace()
        }
    }
}

@Composable
private fun ChannelState(
    channelState: MutableState<Io.RssState?>,
    modifier: Modifier = Modifier.width(256.dp)
) {

    AnimatedVisibility(
        visible = channelState.value != null,
        enter = fadeIn() + expandVertically(),
        exit = fadeOut() + shrinkVertically()
    ) {
        channelState.value?.also {
            val last = remember(it) {
                if (it.dtLast == LocalDateTime.EMPTY) ""
                else it.dtLast.toInstant(TimeZone.UTC).toLocalDateTime(TimeZone.currentSystemDefault()).format(DATE_FORMAT)
            }
            val next = remember(it) {
                if (it.dtLast == LocalDateTime.EMPTY) ""
                else it.dtLast.toInstant(TimeZone.UTC)
                    .plus(it.interval.milliseconds)
                    .toLocalDateTime(TimeZone.currentSystemDefault())
                    .format(DATE_FORMAT)
            }

            Card(modifier) {
                Column(Modifier.fillMaxWidth().padding(16.dp)) {
                    Row {
                        Text(
                            text = Res.string.layer_bottom_editor__rss_reload_dt_last.rememberString(),
                            style = MaterialTheme.typography.labelMedium,
                            modifier = Modifier.weight(1F).align(Alignment.CenterVertically)
                        )
                        Text(last.takeIf { it.isNotEmpty() } ?: Res.string.layer_bottom_editor__rss_reload_in_progress.rememberString())
                    }
                    Space(8.dp)
                    Row {
                        Text(
                            text = Res.string.layer_bottom_editor__rss_reload_dt_next.rememberString(),
                            style = MaterialTheme.typography.labelMedium,
                            modifier = Modifier.weight(1F).align(Alignment.CenterVertically)
                        )
                        Text(next.takeIf { it.isNotEmpty() } ?: Res.string.layer_bottom_editor__rss_reload_in_progress.rememberString())
                    }

                }
            }
        }
    }
}
